// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__fKUk8"};